var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarOutlineGrayThick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.50574L12.6451 6.56898C12.9352 7.4617 13.7671 8.06611 14.7058 8.06611H20.0296L15.7225 11.1954C14.9631 11.7471 14.6454 12.7251 14.9354 13.6178L16.5806 18.681L12.2735 15.5518C11.5141 15 10.4859 15 9.72646 15.5518L5.41942 18.681L7.06456 13.6178C7.35462 12.7251 7.03686 11.7471 6.27747 11.1954L1.97042 8.06611L7.29423 8.06611C8.23288 8.06611 9.06479 7.4617 9.35485 6.56898L11 1.50574Z",
    stroke: "#98A2B3",
    strokeWidth: 2.16667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutlineGrayThick);
export default __webpack_public_path__ + "static/media/star-outline-gray-thick.9330bd82630e35b2c9ff7a536d457888.svg";
export { ForwardRef as ReactComponent };